import { addModuleI18n } from '@kb/i18n';
import bg from './bg.json';
import en from './en.json';
import ru from './ru.json';
import tr from './tr.json';
import uz from './uz.json';
export default addModuleI18n({
    en, ru, bg, tr, uz,
});
